import request from "@/utils/request";

// 大屏畜牧统计数量
const screenBasicCount = (params) => {
  return request(
    params
      ? {
          url: `/api/farm/big/screen/village/basic/${params}`,
          method: "get",
        }
      : {
          url: `/api/farm/big/screen/village/basic/`,
          method: "get",
          params,
        }
  );
};

// 存栏量趋势
const screenExistTrend = (code, year) => {
  return request({
    url: `/api/farm/big/screen/village/exist/trend?code=${code}&year=${year}`,
    method: "get",
  });
};


// 实时动态
const screenDynamic = (params) => {
  return request(
    params
      ? {
          url: `/api/farm/big/screen/village/dynamic/${params}`,
          method: "get",
        }
      : {
          url: `/api/farm/big/screen/village/dynamic/`,
          method: "get",
          params,
        }
  );
};

// 入栏量统计
const screenEnterSta = (code, year) => {
  return request({
    url: `/api/farm/big/screen/village/enter?code=${code}&year=${year}`,
    method: "get",
  });
};

// 出栏量统计
const screenExitSta = (code, year) => {
  return request({
    url: `/api/farm/big/screen/village/exit?code=${code}&year=${year}`,
    method: "get",
  });
};

// 乡镇散点
const screenTownPoints = (params) => {
  return request({
    url: "/api/farm/big/screen/village/town/points",
    method: "get",
    params,
  });
};

// 新政区域
const screenSelectOptions = () => {
  return request({
    url: `/api/system/region/curr/region`,
    method: "get",
  });
};

/**
 * 养殖场类型
 * @returns
 */
const farmTypes = () => {
  return request({
    url: `/api/farm/big/screen/farm/type`,
    method: "get",
  });
};

/**
 * 养殖畜禽类型
 * @returns
 */
const breedTypes = () => {
  return request({
    url: `/api/farm/big/screen/breeder`,
    method: "get",
  });
};

/**
 * 地图养殖场点位展示信息
 * @returns
 */
const farmPoints = (code) => {
  return request({
    url: `/api/farm/big/screen/points/${code}`,
    method: "get",
  });
};

export default {
  screenBasicCount,
  screenExistTrend,
  screenEnterSta,
  screenExitSta,
  screenDynamic,
  screenTownPoints,
  screenSelectOptions,
  farmTypes,
  breedTypes,
  farmPoints,
};
